import { useMemo, type ReactElement } from 'react'
import { useRoles } from '@front/model'
import { MultiSelect, type MultiSelectProps } from '@mantine/core'
import { isRoleId, type RoleId } from '@terros/common'

type Props = Omit<MultiSelectProps, 'data' | 'onChange' | 'value'> & {
  value: RoleId[]
  onChange: (roleIds: RoleId[]) => void
}

export const RoleMultiSelect = ({ value, onChange, ...props }: Props): ReactElement => {
  const { data, isLoading } = useRoles()

  const options = useMemo(() => {
    return data?.map((role) => ({ value: role.roleId, label: role.name })) ?? []
  }, [data])

  return (
    <MultiSelect
      data={options}
      value={value}
      onChange={(values) => onChange(values.filter(isRoleId))}
      {...props}
      disabled={props.disabled || isLoading}
      searchable
      clearable
    />
  )
}
